import classNames from 'clsx';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useOnboardingContext } from '@swf/components/Onboarding/OnboardingContext/OnbordingContext';
import type { Dispatch } from '@swf/core/store';

import { ModalRoute, OnboardingStep } from '../../types';
import type { Game, GameTypeName } from '../../types/Game';

import Tile from './Tile';

export interface LocationState {
  isFlash: boolean;
  gameType: GameTypeName;
  scriptId: number;
  buyIn: string;
  promoRef: string;
}

interface TileListProps {
  tiles: Game[];
  showOnboarding: boolean;
  selectedId: number;
  onGameSelect: (game: Game) => void;
  gameType: GameTypeName;
}

const TileList: React.FC<TileListProps> = ({
  tiles,
  showOnboarding,
  selectedId,
  onGameSelect,
  gameType
}) => {
  const { setFlowToStep, activeStep, onboardingFinished } = useOnboardingContext();
  const { modal } = useDispatch<Dispatch>();
  const handleInfoClicked = useCallback(
    (locationState: LocationState) =>
      modal.enqueue({ path: ModalRoute.PrizeDistribution, locationState }),
    [modal]
  );
  const onboardingFocused = [OnboardingStep.GameTile, OnboardingStep.GameInformation].includes(
    activeStep
  );

  return (
    <>
      {tiles.map((tile, index) => {
        const isOnboardingVisible = index === 0 && showOnboarding;

        return (
          <Tile
            key={tile.scriptId}
            className={classNames({
              onboardingFocus: !onboardingFinished && onboardingFocused && isOnboardingVisible
            })}
            tile={tile}
            gameType={gameType}
            isActive={selectedId === tile.scriptId}
            onSelect={onGameSelect}
            onInfoClick={() =>
              handleInfoClicked({
                isFlash: tile.isFlash,
                gameType,
                scriptId: tile.scriptId,
                buyIn: tile.buyIn,
                promoRef: tile.promoRef
              })
            }
            infoRef={
              isOnboardingVisible && setFlowToStep
                ? setFlowToStep(OnboardingStep.GameInformation)
                : null
            }
            containerRef={
              isOnboardingVisible && setFlowToStep ? setFlowToStep(OnboardingStep.GameTile) : null
            }
          />
        );
      })}
    </>
  );
};
export default TileList;
